import ContactMeMain from "../components/ContactMe/ContactMeMain";

function ContactMe(){
    return(
        <>
            <div className="container">
                <ContactMeMain/>
            </div>
        </>
    );
}

export default ContactMe;